<template>
  <header class="guidance-center-header">
    <h3>作物生长指导模型</h3>
    <div>生育期驱动 | 环境因子耦合 | 策略自动生成</div>
  </header>
</template>

<style lang="less" scoped>
.guidance-center-header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 40px;
}

.guidance-center-header h3 {
  flex: 1;
  margin: 0;
  color: #ffffff;
  font-size: 58px;
  font-weight: bold;
  line-height: 86px;
  text-align: left;
  letter-spacing: 1px;
  text-shadow: 0 0 16px rgba(255, 255, 255, 0.35);
}

.guidance-center-header div {
  min-width: 620px;
  padding: 0 0 10px 26px;
  border-bottom: 3px solid #50fff0;
  color: #effffd;
  font-size: 26px;
  font-weight: bold;
  line-height: 42px;
  text-align: right;
  box-shadow: 0 1px 0 rgba(80, 255, 240, 0.22);
}
</style>
